<div class="pt-20 sm:pt-24 md:pt-28 lg:pt-32 max-h-[calc(100vh-10rem)] overflow-auto">

  <div class="container mx-auto px-4 py-4">

    @if(establishments().length>0   ){
    <features-establishemnts-general
      [establishments]="establishments()"
      [isLoading]="isLoading"
      (visitClick)="navigateToProducts($event)"
    ></features-establishemnts-general>
   }@else {
    <div class="text-center">
      <p class="text-lg font-medium text-gray-600">No tienes establecimientos favoritos</p>
    </div>
   }
  </div>


</div>
